import find from "lodash/find";
import { ChatState } from "PFApp/components/chat/chat_states";
import { getTargetType, getTargetUrl } from "PFCore/helpers/conversation";
import { getProfileName } from "PFCore/helpers/profile";
import { Conversation, CurrentProfile } from "PFTypes";
import { ChatParticipant } from "PFTypes/chat_participant";
import { ProfileMinimized } from "PFTypes/profile";

export const getOtherPerson = (participants: ChatParticipant[], currentProfile: CurrentProfile) =>
  find(participants, ({ profile }) => profile.id !== currentProfile.id)?.profile || null;

type GetChatHeaderInfoParams = {
  chatState: ChatState;
  conversation: Conversation;
  currentParticipant: ChatParticipant;
  otherPerson: ProfileMinimized | null;
};

type ChatHeaderInfo = {
  title: string;
  isFollowing: boolean;
  targetUrl: string | false;
};

const getProfileTargetInfo = (
  otherPerson: ProfileMinimized | null
): Pick<ChatHeaderInfo, "title" | "targetUrl"> => {
  if (!otherPerson) {
    return { title: "", targetUrl: false };
  }
  return { title: getProfileName(otherPerson), targetUrl: `/profiles/${otherPerson.id}` };
};

const getNormalHeaderInfo = (
  conversation: Conversation,
  currentParticipant: ChatParticipant,
  otherPerson: ProfileMinimized | null
): ChatHeaderInfo => {
  const isProfileTarget = getTargetType(conversation) === "Profile";
  const { title, targetUrl } = isProfileTarget
    ? getProfileTargetInfo(otherPerson)
    : { title: conversation.title, targetUrl: getTargetUrl(conversation) };

  return { title, targetUrl, isFollowing: currentParticipant.notificationState === "following" };
};

export const getChatHeaderInfo = ({
  chatState,
  conversation,
  currentParticipant,
  otherPerson
}: GetChatHeaderInfoParams): ChatHeaderInfo => {
  if (chatState === ChatState.Loading) {
    return { title: "...", isFollowing: false, targetUrl: getTargetUrl(conversation) };
  }

  return getNormalHeaderInfo(conversation, currentParticipant, otherPerson);
};
